"use client";

import {
  calculateDiscountPercentage,
  formatCurrencyWithSign,
} from "@/lib/utils";
import Image from "next/image";
import React from "react";
import "./FashionProductCard.scss";
import Link from "next/link";
import { usePathname } from "next/navigation";

const FashionProductCard = ({ product, currency }) => {
  const { images, title, sold_out, handle, variant_detail } = product;
  const pathname = usePathname();

  const { original_price, discounted_price, max_original_price, max_discounted_price } =
    variant_detail;

  const displayOriginalPrice =
    max_original_price !== undefined ? max_original_price : original_price;
  const displayDiscountedPrice =
    max_discounted_price !== undefined ? max_discounted_price : discounted_price;

  const discount =
    displayDiscountedPrice && displayDiscountedPrice < displayOriginalPrice
      ? calculateDiscountPercentage(displayOriginalPrice, displayDiscountedPrice)
      : 0;

  const isMenSection = pathname.includes("/fashion/men");
  const productLink = isMenSection
    ? `/fashion/men/${handle}`
    : `/fashion/${handle}`;

  const imageSrc =
    typeof images?.[0] === "string"
      ? images[0]
      : images?.[0]?.cdn_link || "";

  return (
    <div className="fashion-product-card">
      <div className="image-container">
        <Link href={productLink} className="image-link">
          <Image
            src={imageSrc}
            alt={title}
            fill
            sizes="(max-width: 679px) 50vw, 320px"
            className="product-image"
          />
        </Link>

        {sold_out && (
          <div className="sold-out-badge badge">
            <span>Sold Out</span>
          </div>
        )}

        {!sold_out && discount > 0 && (
          <div className="discount-badge badge">
            <span>-{discount}%</span>
          </div>
        )}
      </div>

      <div className="product-info">
        <Link href={productLink}>
          <h3 className="product-title">{title}</h3>
        </Link>

        <div className="product-price-row">
          {discount > 0 && (
            <p
              style={{ textDecoration: "line-through" }}
              className="original-price product-price"
            >
              {formatCurrencyWithSign(displayOriginalPrice, currency)}
            </p>
          )}
          <p
            style={{ color: discount > 0 ? "#E32F20" : "#2F2F2F" }}
            className="final-price product-price"
          >
            {formatCurrencyWithSign(displayDiscountedPrice, currency)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FashionProductCard;
